import React, { useState } from 'react';
import 'twin.macro';
import EditableTextComponent from 'components/Form/EditableText';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';
import { ExclamationTriangleIcon } from '@heroicons/react/16/solid';
import tw from 'twin.macro';

interface Props {
  value: string;
  onChange: (v: string) => void;
  exactLength?: number;
  readonly?: boolean;
}

export function TextCell(props: Props) {
  const { onChange, value, exactLength } = props;
  const { hasXcharacters } = useTranslatedValidation();
  const [inputValue, setInputValue] = useState<string>(value);

  const error = exactLength
    ? hasXcharacters(exactLength)(inputValue)
    : undefined;

  if (props.readonly) {
    return <div>{value}</div>;
  }

  return (
    <div>
      <EditableTextComponent
        // h-7 c'est pour qu'il ait la même haute que les autres inputs
        css={[tw`text-sm font-medium h-7`, error && tw`text-danger`]}
        autoSize={false}
        // C'est moche mais ça permet d'avoir une taille min si l'input est vide
        // j'ai pas trouvé comment faire mieux rapidement, mais bon ça fait le taf
        placeholder="                "
        value={value}
        onConfirm={e => {
          setInputValue(e);
          onChange(e);
        }}
      />
      {error && (
        <span tw="flex items-center gap-2 mt-1 text-xs text-danger">
          <ExclamationTriangleIcon tw="w-4 h-4 shrink-0" />
          {error}
        </span>
      )}
    </div>
  );
}
